import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { PENDING, IDLE } from "const"
import { MtAccountPackage } from "server/models"
import { deepCopy, StateType } from "client/utils"
import {
    StoreType,
    AccountProps,
    AccountPackageList,
    LoadAccountPackages,
    setAccountPackageList,
    addModal,
} from "client/store"
import {
    Container,
    PageContent,
    Loader,
    Table,
    Button,
} from "client/components"

import SubscriptionButton from "client/pages/mt/billing/subscriptionButton"
import Columns from "./columns"
import EditAccountPackage from "./edit"

type MtAccountPackageList = {[key: number]: MtAccountPackage}

const AssignedPackages = ({
    accountId = 0,
}: AccountProps) => {
    const accountPackageList = useSelector((state: StoreType) => state.accountPackage.accountPackageList)
    const reloadList = useSelector((state: StoreType) => state.accountPackage.reloadList)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [dataList, setDataList] = useState<MtAccountPackageList>(null)
    const [dataIds, setDataIds] = useState<number[]>(null)
    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        if (!reloadList) return
        setLoadState(PENDING)
        LoadAccountPackages(accountId).then((packageList) => {
            const accountPackageListCopy: AccountPackageList = accountPackageList ? deepCopy(accountPackageList) : {}
            accountPackageListCopy[accountId] = packageList
            dispatch(setAccountPackageList(accountPackageListCopy))

            const list: MtAccountPackageList = {}
            const ids: number[] = []
            packageList.forEach((row) => {
                list[row.id] = row
                ids.push(row.id)
            })
            setDataList(list)
            setDataIds(ids)
            setLoadState(IDLE)
        })
    }, [reloadList])

    const columns = Columns()

    return (
        <Container>
            <PageContent>
                {loadState === PENDING && <Loader />}
                <Table
                    columns={columns}
                    dataList={dataList}
                    dataIds={dataIds}
                    sortColumn={null}
                    sortOrder={null}
                    rowSize="sm"
                    bottomContent={userData.accountId === 1 && (
                        <Button
                            variant="success"
                            onClick={() => dispatch(addModal({
                                key: "addPackage",
                                content: <EditAccountPackage id={0} accountId={accountId} />,
                            }))}
                        >
                            {lang.add}
                        </Button>
                    )}
                />

                <SubscriptionButton />
            </PageContent>
        </Container>
    )
}
export default AssignedPackages
